const SSD_1029_FAKE_CC_API_REQUIRE_FIELD = 'SSD-1029-fake-cc-api-require-field';
const PD_349_IFTI_DELIGHTER = 'PD-349-ifti-delighter';
const PD_1135_MONOOVA_BPAY = 'PD-1135-monoova-bpay';
const PD_1299_NEWTON_OPPORTUNITIES = 'PD-1299-newton-opportunities';
const PD_1325_DIRECT_DEBIT = 'PD-1325-direct-debit';
const PD_1348_CAPTCHA = 'PD-1348-captcha';
const PD_1272_BENE_CREATION = 'PD-1272-bene-creation';
const PD_1565_CARD_NUMBER = 'PD-1565-card-number';
const PD_1617_BENE_HEADER = 'PD-1617-bene-header';
const PD_1619_BENE_TEXT = 'PD-1619-bene-text';
const PD_1832_REPORT_ISSUE = 'PD-1832-report-issue';
const PD_1864_BENE_EDIT = 'PD-1864-bene-edit';
const PD_2244_CC_ROLLER = 'PD-2244-cc-roller';
const PD_2049_IFTI_BATCH_SUBMIT = 'PD-2049-ifti-batch-submit';
const PD_2061_MANDATORY_MFA = 'PD-2061-mandatory-mfa';
const PD_2160_VRN_CREATION = 'PD-2160-vrn-creation';
const PD_2197_PORTAL_TO_HUB_AUTH_REDIRECT = 'PD-2197-portal-to-hub-auth-redirect';

module.exports = {
  SSD_1029_FAKE_CC_API_REQUIRE_FIELD,
  PD_349_IFTI_DELIGHTER,
  PD_1135_MONOOVA_BPAY,
  PD_1299_NEWTON_OPPORTUNITIES,
  PD_1325_DIRECT_DEBIT,
  PD_1348_CAPTCHA,
  PD_1272_BENE_CREATION,
  PD_1565_CARD_NUMBER,
  PD_1617_BENE_HEADER,
  PD_1619_BENE_TEXT,
  PD_1832_REPORT_ISSUE,
  PD_1864_BENE_EDIT,
  PD_2244_CC_ROLLER,
  PD_2049_IFTI_BATCH_SUBMIT,
  PD_2061_MANDATORY_MFA,
  PD_2160_VRN_CREATION,
  PD_2197_PORTAL_TO_HUB_AUTH_REDIRECT,
};
